// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgReports = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.25 3.6c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h4.65V9.6c0-.746.604-1.35 1.35-1.35h4.65zm0 6.15h-4.5v10.5h4.5zm1.5 10.5h4.5V3.75h-4.5zm-7.5 0v-3.5h-4.5v3.5z"
      clipRule="evenodd"
    />
  </svg>
);
export const ReportsIcon = forwardRef(SvgReports);
